var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommunication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 12.1836H32.0005M11.9998 16.1834H32.0005M11.9998 20.1831H28.0016M52.7315 20.1831L27.2725 20.1852C23.2583 20.1852 20.0007 23.4415 20.0007 27.4584V38.3655C20.0007 42.3853 23.2556 45.6429 27.2725 45.6429V45.6374C28.2771 48.0689 28.2 50.6665 27.2725 52.9134C31.2895 52.9134 34.5471 49.6606 34.5471 45.6387H45.4528C53.4866 45.6387 60.002 39.1276 60.002 31.0923V27.4612C60.0021 23.4415 56.7473 20.1831 52.7315 20.1831Z",
    stroke: "url(#paint0_linear_180_6387)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5001 27.9134H52.503M27.5001 32.9115H52.503M27.5001 37.9124H47.5035M27.2726 20.1854L36.6391 20.1847C37.5348 18.5051 38.0024 16.6305 38.0007 14.727V11.8221C38.0007 8.6065 35.3962 6 32.1853 6L11.818 6.00135C8.60729 6.00135 6 8.6065 6 11.8194V20.5459C6 23.7622 8.60446 26.368 11.818 26.368V26.3638C12.6228 28.3082 12.5621 30.3877 11.818 32.1846C15.0316 32.1846 17.6389 29.5815 17.6389 26.3652H20.111C20.6416 22.8712 23.6318 20.1854 27.2726 20.1854ZM43.2289 49.9475H64.7702C69.8661 49.9475 74.0002 54.0795 74.0002 59.1782C74.0002 64.2754 69.8661 68.4095 64.7702 68.4095H63.7891C63.0174 70.2782 63.078 72.2736 63.7891 74.0001C60.7022 74.0001 58.1997 71.5004 58.1942 68.4095H43.2289C38.1328 68.4095 34.0002 64.2754 34.0002 59.1782C34.0002 54.0795 38.1328 49.9475 43.2289 49.9475Z",
    stroke: "url(#paint1_linear_180_6387)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3847 59.1784C59.3847 60.453 60.4182 61.4866 61.6943 61.4866C62.9676 61.4866 64.0012 60.453 64.0012 59.1784C64.0012 57.9037 62.9677 56.8701 61.6943 56.8701C60.4182 56.87 59.3847 57.9037 59.3847 59.1784ZM51.6898 59.1784C51.6898 60.453 52.726 61.4866 53.9993 61.4866C55.2726 61.4866 56.3063 60.453 56.3063 59.1784C56.3063 57.9037 55.2727 56.8701 53.9993 56.8701C52.7259 56.8701 51.6898 57.9037 51.6898 59.1784ZM43.9976 59.1784C43.9976 60.453 45.0339 61.4866 46.3072 61.4866C47.5804 61.4866 48.614 60.453 48.614 59.1784C48.614 57.9037 47.5805 56.8701 46.3072 56.8701C45.0338 56.8701 43.9976 57.9037 43.9976 59.1784Z",
    stroke: "url(#paint2_linear_180_6387)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_180_6387",
    x1: 12,
    y1: 32.5488,
    x2: 60.002,
    y2: 32.5488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_180_6387",
    x1: 6.00034,
    y1: 40.0006,
    x2: 74.0002,
    y2: 40.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_180_6387",
    x1: 43.9977,
    y1: 59.1784,
    x2: 64.0012,
    y2: 59.1784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication);
export default __webpack_public_path__ + "static/media/Communication.c9f22e8f0a1a9581b4690740bf879b1f.svg";
export { ForwardRef as ReactComponent };